// extracted by mini-css-extract-plugin
module.exports = {"container":"e_C4","link":"e_D4","imageContainer":"e_E4","author":"e_F4","text":"e_G4","buttonIcon":"e_H4"};